
import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const QuestionMarkTooltip = ({ text }) => (
  <Tooltip title={text}>
    <QuestionCircleOutlined />
  </Tooltip>
);
export default QuestionMarkTooltip;
